export function LayoutPageBlankContentWrapper({ children }) {
  return <div className="mx-auto bg-gray-900 ">{children}</div>;
}
